var _style, _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000098929423765655557080000000341133866722388390_);}\n\t.st1{fill:#23A566;}\n\t.st2{fill:#1C8F5A;}\n\t.st3{fill:#8ED1B1;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 1024,
    height: 1024
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000173131401561002436080000013138694571128773030_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000173131401561002436080000013138694571128773030_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M879.5,964.824c0,32.676-26.473,59.176-59.115,59.176h-616.77c-32.642,0-59.115-26.5-59.115-59.176V59.424 c0-32.677,26.473-59.176,59.115-59.176h396.567L879.5,286.638V964.824L879.5,964.824z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M630.968,279.371L879.5,517.059l-0.733-230.788l-0.417-0.012H658.8c-10.003,0-19.425-2.491-27.685-6.884 L630.968,279.371L630.968,279.371z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M879.5,286.26H658.8c-32.642,0-59.115-26.5-59.115-59.176V0L879.5,286.26L879.5,286.26z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M703.136,834.635H320.863V503.247h382.273V834.635L703.136,834.635z M535.64,550.589v59.176h120.205v-59.176 H535.64L535.64,550.589z M535.64,645.271v55.235h120.205v-55.235H535.64L535.64,645.271z M535.64,736.012v51.282h120.205v-51.282 H535.64L535.64,736.012z M488.348,787.294v-51.282H368.155v51.282H488.348L488.348,787.294z M488.348,700.506v-55.235H368.155 v55.235H488.348L488.348,700.506z M488.348,609.765v-59.176H368.155v59.176H488.348L488.348,609.765z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetLogo);
export default __webpack_public_path__ + "static/media/sheet-logo.9bd6b5b406e5b97a0df9acefa190955c.svg";
export { ForwardRef as ReactComponent };